import { ReactElement } from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { orientations, paperFormats } from '../../constants'
import {
  PlanTemplateConfiguration,
  findCustomPlanTemplate,
  planTemplateConfigurationKey,
} from '../../utils'
import PlanTemplateTableRow from '../PlanTemplateTableRow'

interface Props {
  planType: PlanTemplateType
  customTemplates: CustomerFile<PlanTemplateAdditionalData>[]
  onDownloadDefault: (configuration: PlanTemplateConfiguration) => void
  downloadingConfiguration?: PlanTemplateConfiguration
  onUpload: (configuration: PlanTemplateConfiguration, file: File) => void
  uploadingConfiguration?: PlanTemplateConfiguration
  onDelete: (
    configuration: PlanTemplateConfiguration,
    customTemplate: CustomerFile<PlanTemplateAdditionalData>,
  ) => void
  deletingConfiguration?: PlanTemplateConfiguration
}

const PlanTemplateTable = ({
  planType,
  customTemplates,
  onDownloadDefault,
  downloadingConfiguration,
  onUpload,
  uploadingConfiguration,
  onDelete,
  deletingConfiguration,
}: Props): ReactElement => {
  const configurations: PlanTemplateConfiguration[] = paperFormats.flatMap(paperFormat =>
    orientations.map(orientation => ({ planType, paperFormat, orientation })),
  )

  const isSameConfiguration = (a: PlanTemplateConfiguration, b?: PlanTemplateConfiguration) =>
    !!b && planTemplateConfigurationKey(a) === planTemplateConfigurationKey(b)

  return (
    <Table size="small" data-cy={`plan-template-table-${planType}`}>
      <TableHead>
        <TableRow>
          <TableCell>Format</TableCell>
          <TableCell align="center">Ausrichtung</TableCell>
          <TableCell align="center">Vorlage</TableCell>
          <TableCell align="center">Standardvorlage</TableCell>
          <TableCell align="center">Eigene Vorlage</TableCell>
          <TableCell align="center">Neue Vorlage hochladen</TableCell>
          <TableCell align="center">Aktionen</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {configurations.map(configuration => {
          const customTemplate = findCustomPlanTemplate(customTemplates, configuration)

          return (
            <PlanTemplateTableRow
              key={planTemplateConfigurationKey(configuration)}
              configuration={configuration}
              customTemplate={customTemplate}
              onDownloadDefault={() => onDownloadDefault(configuration)}
              isDownloadingDefault={isSameConfiguration(configuration, downloadingConfiguration)}
              onUpload={file => onUpload(configuration, file)}
              isUploading={isSameConfiguration(configuration, uploadingConfiguration)}
              onDelete={() => customTemplate && onDelete(configuration, customTemplate)}
              isDeleting={isSameConfiguration(configuration, deletingConfiguration)}
            />
          )
        })}
      </TableBody>
    </Table>
  )
}

export default PlanTemplateTable
